import { AvailableLanguages } from '@repo/toolkit/language-types'
import { TFunction } from 'i18next'

import i18n from '../../i18n'

export const t = i18n.t as unknown as TFunction<AvailableLanguages>
